import * as React from 'react';
import PT from 'prop-types';
import classNames from 'classnames';
import { dataLayerEvents } from 'common/utils';
import { MAIL_TO_ANALYTICS } from 'client/constants';

import * as css from './MailTo';

const MailTo = ({ className, children, isSticky, ...props }) => {
	const mail = 'podcast@jobs.rafael.co.il';

	const onBtnClick = () => {
		dataLayerEvents.onCVBtnClick(MAIL_TO_ANALYTICS.FOOTER);
	};

	return (
		<a href={`mailto:${mail}`} className={classNames(className, css.mailTo)} {...props} onClick={onBtnClick}>
			<i className={css.iconClip} />
			{children}
		</a>
	);
};

MailTo.defaultProps = {
	className: '',
	children: null,
	isSticky: false,
};

MailTo.propTypes = {
	className: PT.string,
	children: PT.node,
	isSticky: PT.bool,
};

export default MailTo;
